




























import { Component, Prop, Vue } from 'vue-property-decorator';

import NumericField from './NumericField.vue';

@Component({
  inheritAttrs: false,
  components: {
    NumericField
  }
})
export default class BaseNumericField extends Vue {
  $refs!: {
    input: HTMLInputElement
  };

  @Prop()
  private readonly label!: string;

  @Prop({ default: 1000000 })
  private maxValue!: number;

  get slots(): string[] {
    return Object.keys(this.$slots).filter(slot => slot !== 'label');
  }

  focus() {
    this.$nextTick(() => {
      this.$refs.input.focus();
    });
  }
}
